import React, { useState } from "react";
import { ArrowRight, Briefcase, Search, Users } from "lucide-react";
import "./css/PostJob.css";
import HeaderFour from "../../common/header/HeaderFour";
import FooterOne from "../../common/footer/FooterOne";
import RegisterPopup from "./RegisterPopup";
import SEO from "../../common/SEO";

const PostJob = () => {
  const [formData, setState] = useState({
    email: "",
    password: "",
  });

  const [isRegisterPopupOpen, setIsRegisterPopupOpen] = useState(false);

  const handleChange = (e) => {
    setState({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log("Form submitted:", formData);
  };

  const openRegisterPopup = (e) => {
    e.preventDefault();
    setIsRegisterPopupOpen(true);
  };

  return (
    <>
      <SEO />
      <main className="main-wrapper">
        <HeaderFour />
        <div className="section section-padding">
          <br /> <br />
          <br />
          <div className="container-fluid">
            <div className="row g-0">
              {/* Left Panel */}
              <div className="col-md-7 left-panel">
                <div className="contents-wrapper">
                  <div className="hero-content">
                    <h1>Find your Ideal Hire</h1>
                    <p className="sub-heading">
                      Get exclusive access to highly coveted trained talent pool
                      of CLIF AI candidates
                    </p>

                    <div className="stats-container">
                      <div className="stat-item">
                        <h2>5,00,000+</h2>
                        <p>Verified Talent</p>
                      </div>
                      <div className="stat-item">
                        <h2>Zero</h2>
                        <p>Hiring Cost</p>
                      </div>
                      <div className="stat-item">
                        <h2>4000+</h2>
                        <p>Hiring Companies</p>
                      </div>
                    </div>

                    <div className="hiring-process">
                      <h3>Start Hiring Now</h3>

                      <div className="steps-container">
                        <div className="step-card">
                          <div className="step-icon">
                            <Users size={30} color="#6600CC" />
                          </div>
                          <span className="step-number">Step 1</span>
                          <h4>Register with CLIF AI</h4>
                        </div>

                        <div className="step-card">
                          <div className="step-icon">
                            <Briefcase size={30} color="#6600CC" />
                          </div>
                          <span className="step-number">Step 2</span>
                          <h4>Select a role and post a job</h4>
                        </div>

                        <div className="step-card">
                          <div className="step-icon">
                            <Search size={30} color="#6600CC" />
                          </div>
                          <span className="step-number">Step 3</span>
                          <h4>Connect with the right talent</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Panel - Form */}
              <div className="col-md-5 right-panel">
                <div className="form-container">
                  <h2>Post a job for free</h2>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Enter your password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <button type="submit" className="btn btn-primary btn-submit try-free-btn">
                      Login <ArrowRight size={16} />
                    </button>

                    <div className="register-link">
                      Don't have an account?{" "}
                      <a href="#" onClick={openRegisterPopup}>
                        Register
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterOne parentClass="" />

        {/* Register Popup */}
        <RegisterPopup
          isOpen={isRegisterPopupOpen}
          onClose={() => setIsRegisterPopupOpen(false)}
        />
      </main>
    </>
  );
};

export default PostJob;
